import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolAction } from '../symbol.action';

export const endSymbolProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolAction.create.failed,
    SymbolAction.update.failed,
    SymbolAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      SymbolAction.processing.done({}),
    ];
  }),
);
